module.exports = __webpack_public_path__ + "static/media/Footer Adornment.9f74abd6.svg";